export default class FeatureBits {
    public static readonly isAuthRequired = false;
}